import styled from 'styled-components'
import { bp } from 'lib/core/resources/helpers/styled'

export const Container = styled.div`
  max-width: ${props => props.theme.maxWidth};
  margin: auto;
  background: ${props => props.theme.palette.primary.alphaDark};
  padding: 20px 0;
  color: ${props => props.theme.palette.general.light};
  text-align: center;
  ${bp('lg')`
    padding: 15px 0;
  `}

  > div {
    padding: 0 60px;
    ${bp('sm')`
      padding: 0 30px;
    `}
  }

  h1 {
    ${props => props.theme.css.heading2};
    margin: 0;
  }
`
